/**
 * Determines if two page IDs represent the same page
 * @param targetPageId - The target page ID
 * @param currentPageId - The current page ID
 * @returns true if both page IDs exist and are equal
 */
export const isSamePage = (
    targetPageId: string | undefined,
    currentPageId: string | undefined,
): boolean => {
    return !!targetPageId && !!currentPageId && targetPageId === currentPageId;
};

export const addScrollToParam = (url: string, componentId: string): string => {
    if (!componentId) {
        return url;
    }

    try {
        const urlObj = new URL(url);
        urlObj.searchParams.set('scrollTo', componentId);
        return urlObj.toString();
    } catch {
        // If URL parsing fails, append manually
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}scrollTo=${encodeURIComponent(componentId)}`;
    }
};

export const getScrollToParam = (url?: string): string | null => {
    try {
        const urlObj = new URL(url || window.location.href);
        return urlObj.searchParams.get('scrollTo');
    } catch {
        return null;
    }
};
